<template>
    <td :colspan="colspan" style="text-align: center;">
        <b>Carry over</b> - setting will carry over
    </td>
</template>

<script>
export default {
    props: [
        'colspan'
    ]
}
</script>